import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { ChatResponse } from '@/types';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://chipchip-ai-agent.vercel.app/api/v1';

export const chatApi = createApi({
  reducerPath: 'chatApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Chat'],
  endpoints: (builder) => ({
    chat: builder.mutation<ChatResponse, { input: string; session_id?: string }>({
      query: ({ input, session_id }) => ({
        url: `chat${session_id ? `?session_id=${session_id}` : ''}`,
        method: 'POST',
        body: { input },
      }),
      transformErrorResponse: (response: any) => {
        return {
          message: response?.data?.error || 'An error occurred while processing your request',
          status: response?.status,
        };
      },
    }),
  }),
});

export const { useChatMutation } = chatApi;